<template>
	<div class="page flex-col">
		<div class="group_1 flex-col align-center">
			<div class="box_1 flex-col">
				<div class="group_2 flex-row align-center justify-between">
					<span class="text_1">猩潮宇宙</span>
					<div class="flex-row">
						<div class="group_12 flex-col" @click="clickTabIndex(0,'scroll0')">
							<span :class="tabSelectIndex==0?'text_3':'text_4'">首页</span>
							<div v-if="tabSelectIndex==0" class="group_3 flex-col"></div>
						</div>
						<div class="group_12_1 flex-col" @click="clickTabIndex(1,'scroll1')">
							<span :class="tabSelectIndex==1?'text_3':'text_4'">企业愿景</span>
							<div v-if="tabSelectIndex==1" class="group_3 flex-col"></div>
						</div>
						<div class="group_12_1 flex-col" @click="clickTabIndex(2,'scroll2')">
							<span :class="tabSelectIndex==2?'text_3':'text_4'">产品介绍</span>
							<div v-if="tabSelectIndex==2" class="group_3 flex-col"></div>
						</div>
						<div class="group_12_1 flex-col" @click="clickTabIndex(3,'scroll3')">
							<span :class="tabSelectIndex==3?'text_3':'text_4'">联系我们</span>
							<div v-if="tabSelectIndex==3" class="group_3 flex-col"></div>
						</div>
					</div>
				</div>
			</div>
			<img id="scroll0" class="image_7" referrerpolicy="no-referrer"
				src="./assets/img/28112e18791ceb12ae595bb3d18d9a77.png" />
			<div id="scroll1" class="flex-col align-center" style="width: 100%;">
				<span class="text_7">企业愿景</span>
				<div class="text-group_6 flex-col">
					<span class="text_8">“让我们享受娱乐，开始新的生活!”</span>
					<span class="paragraph_2">
						我们的目标是将只有在现实生活中才能体验到的丰富娱乐带到网上。
						<br />
						我们重视只有在这里才能感受到的乐趣和乐趣，我们希望创造一个环境，
						<br />
						让玩家可以更公平地互动和玩要，以泰国的方式我们努力重新定义新娱乐的概念，并将真实的在线体验带入生活。
						<br />
					</span>
				</div>
				<!-- <div class="text-wrapper_3 flex-col">
					<span class="text_9">張浩&nbsp;&nbsp;&nbsp;代表取締役</span>
					<span class="paragraph_3">
						トレジャーハブを立ち上げる前には、
						<br />
						別のインターネット企業で取締役
						<br />
						総裁およびパートナーを兼任していました。
					</span>
				</div> -->
			</div>
			<div id="scroll2" class="block_1 flex-col">
				<div class="block_7 flex-row justify-between">
					<div class="box_17 flex-col">
						<div class="text-wrapper_4">
							<span class="text_10">猩潮宇宙</span>
						</div>
						<div class="text-group_7 flex-col justify-between">
							<div class="text-wrapper_5">
								<span class="paragraph_5">
									这是一款可以随时随地玩的在线购物。
									<br />
									有各种流行的动漫人物。
									<br />
									享受各种游戏方式和各种奖品
								</span>
							</div>
							<span class="text_11">这是一款 24 小时在线购物平台</span>
						</div>
						<div class="box_18 flex-row">
							<div class="text-wrapper_6 flex-col"><span class="text_12">安卓下载</span></div>
							<div class="text-wrapper_7 flex-col"><span class="text_13">iOS下载</span></div>
						</div>
					</div>
					<div class="box_8 flex-col">
						<div class="text-group_8 flex-col justify-between">
							<div class="text-wrapper_8">
								<span class="text_14">猩潮宇宙</span>
							</div>
							<span class="text_15">现在让我们购物吧！</span>
						</div>
						<img class="image_1" referrerpolicy="no-referrer"
							src="./assets/img/29fd7728ecedaf8aeed8ac9989021fba.png" />
						<div class="image-wrapper_1 flex-col">
							<img class="image_2" referrerpolicy="no-referrer"
								src="./assets/img/92de833ca5d028bb89d1910640ac8e14.png" />
						</div>
						<img class="image_3" referrerpolicy="no-referrer"
							src="./assets/img/ae095718d3cbad095599baac1c2430b9.png" />
					</div>
				</div>
				<!-- <div class="block_8 flex-row justify-between">
					<div class="box_19 flex-col">
						<div class="text-group_9 flex-col">
							<span class="paragraph_8">
								ハートビート&nbsp;
								<br />
								の瞬間
							</span>
							<span class="text_16">香港で&nbsp;発売中</span>
						</div>
						<div class="block_2">
							<div class="image-wrapper_2 flex-col">
								<img class="image_4" referrerpolicy="no-referrer"
									src="./assets/img/7e58231dd2f47d723340eb92979608f0.png" />
								<img class="image_5" referrerpolicy="no-referrer"
									src="./assets/img/7a4cc2edb8578d2300ffe24926b4aa29.png" />
							</div>
						</div>
					</div>
					<div class="box_20 flex-col">
						<div class="text-wrapper_9">
							<span class="paragraph_10">
								Heartbeat
								<br />
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Moments
							</span>
						</div>
						<div class="text-group_10 flex-col justify-between">
							<span class="paragraph_11">
								心臓の鼓動が速まるゲームの瞬間を感じ、
								<br />
								大奨を獲得しましょう！さあ、挑戦しましょう！
							</span>
							<span class="text_17">オンラインソーシャルスロットゲームサービス</span>
						</div>
						<div class="block_9 flex-row justify-between">
							<div class="text-wrapper_10 flex-col"><span class="text_18">ダウンロード方法</span></div>
							<div class="text-wrapper_11 flex-col"><span class="text_19">ソーシャルアカウント</span></div>
						</div>
					</div>
				</div> -->

			</div>
			<div id="scroll3" class="flex-col align-center" style="width: 100%;">
				<span class="text_20">公司信息</span>
				<div class="section_1 flex-row justify-between">
					<div class="group_13 flex-col justify-between">
						<div class="text-wrapper_13">
							<span class="text_22">公司名称:</span>
							<span class="text_24">徐州猩潮宇宙文化有限公司</span>
						</div>
						<div class="text-wrapper_14 flex-row">
							<span class="text_25">公司地址:</span>
							<span class="paragraph_14">江苏省徐州市铜山区万达广
								<br />
								场1、2、3、5、8号楼
								<br />
								3-908
							</span>
						</div>
					</div>
					<img class="image_6" referrerpolicy="no-referrer"
						src="./assets/img/1e6f3b6b41fb3deb85dd0372adf2d709.png" />
				</div>
			</div>
			<div id="scroll4" class="flex-col align-center">
				<span class="text_27">联系我们</span>
				<span class="paragraph_16">
					感谢您对猩玩的关注。
					<br />
					请随时与我们联系进行业务联系或面试。
					<br />
				</span>
				<div class="text-wrapper_17">
					<span class="text_28"></span>
					<!-- <span class="text_29">ゲームに関するご質問があれば、</span> -->
					<span class="text_30">contact&#64;xingwanchaoman.com</span>
					<!-- <span class="text_31">までお気軽にお問い合わせください。</span> -->
				</div>
				<!-- <span class="text_32">お名前</span>
				<div class="text-wrapper_18 flex-col">
					<input v-model="userName" placeholder="お名前"
						style="width: calc(100% - 20px);height: calc(100% - 20px);margin: 10px;border: none;font-size: 30px;outline: none" />
				</div>
				<div class="text-wrapper_19">
					<span class="text_34">お問い合わせ種別</span>
					<span class="paragraph_17">
						*
						<br />
						<br />
					</span>
					<span class="text_35"></span>
				</div>
				<div class="section_2 flex-row justify-between">
					<div class="group_14 flex-col justify-between">
						<div class="flex-row" @click="clickQu(0)">
							<div class="group_5 display-center">
								<div v-if="selectQu==0" class="group_6"></div>
							</div>
							採用に関するお問い合わせ
						</div>
						<div class="flex-row" @click="clickQu(1)">
							<div class="group_5 display-center">
								<div v-if="selectQu==1" class="group_6"></div>
							</div>
							取材のお申し込み
						</div>
						<div class="flex-row" @click="clickQu(2)">
							<div class="group_5 display-center">
								<div v-if="selectQu==2" class="group_6"></div>
							</div>
							サービス導入や提案などのご案内
						</div>
						<div class="flex-row" @click="clickQu(3)">
							<div class="group_5 display-center">
								<div v-if="selectQu==3" class="group_6"></div>
							</div>
							その他
						</div>
					</div>
				</div>
				<span class="text_37">お問い合わせ内容</span>
				<div class="block_6">
					<textarea v-model="userContent" class="text_38" placeholder="お問い合わせ内容"></textarea>
				</div>
				<span class="text_39">メールアドレス</span>
				<div class="text-wrapper_21 flex-col">
					<input v-model="userEmail" placeholder="メールアドレス"
						style="width: calc(100% - 20px);height: calc(100% - 20px);margin: 10px;border: none;font-size: 30px;outline: none" />
					<span v-if="emailError" style="color: red;margin-top: 12px;">正しいメールアドレスを入力してください</span>
				</div> -->
				<!-- <span class="text_41">認証コード</span>
				<div class="text-wrapper_22 flex-col">
					<input v-model="userEmail" placeholder="認証コード"
						style="width: calc(100% - 20px);height: calc(100% - 20px);margin: 10px;border: none;font-size: 30px;outline: none" />
				</div> -->
				<!-- <button class="text-wrapper_23 display-center" @click="clickSend()"><span
						class="text_43">送信する</span></button> -->
				<div class="block_5 flex-col">
					<div class="box_21 flex-row justify-between">
						<div class="text-wrapper_26 flex-col justify-between">
							<span class="text_44">徐州猩潮宇宙文化有限公司</span>
							<span class="paragraph_21">
								徐州猩潮宇宙文化有限公司成立于2024年，是一家经营，周边动漫产品手办、线上app、电商平台等业务的互联网+线下结合企业。
								<br />
								从为顾客提供全方位服务的经营理念出发，专注干产品的娱乐、收藏、价值、活动等综合体验。
								<br />
								主营品牌日本欧哈游漫圈app为市场上人气第一的手办交易APP，韩国建筑合作实体店铺正中心广场中，
								<br />
								所包含的商品种类近万种，包括变形金刚、动漫手办、兵人雕塑、电影周边等正品授权玩具。
								<br />
							</span>
						</div>
						<div class="group_10 flex-col">
							<span class="text_45" @click="clickTabIndex(0,'scroll2')">首页</span>
							<div class="box_15 flex-col" v-if="tabSelectIndex==0"></div>
							<span class="text_46" @click="clickTabIndex(1,'scroll2')">企业愿景</span>
							<div class="box_15 flex-col" v-if="tabSelectIndex==1"></div>
							<span class="text_47" @click="clickTabIndex(2,'scroll2')">产品介绍</span>
							<div class="box_15 flex-col" v-if="tabSelectIndex==2"></div>
							<span class="text_48" @click="clickTabIndex(3,'scroll2')">联系我们</span>
							<div class="box_15 flex-col" v-if="tabSelectIndex==3"></div>
						</div>
					</div>
					<div class="text-wrapper_27 flex-row">
						<span class="text_49">著作权:徐州猩潮宇宙文化有限公司</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
		name: 'homeWord',
		data() {
			return {
				constants: {},
				tabSelectIndex: -1,
				selectQu: 0,
				userName: '',
				userContent: '',
				userEmail: '',
				contents: ['採用に関するお問い合わせ', '取材のお申し込み', 'サービス導入や提案などのご案内', 'その他'],
				isSend: false
			};
		},
		computed: {
			emailError() {
				// 使用正则表达式验证邮箱格式
				const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
				return this.userEmail.length > 0 && !emailPattern.test(this.userEmail);
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			handleScroll() {
				const anchors = ['scroll0', 'scroll1', 'scroll2', 'scroll3'];
				const scrollPosition = window.scrollY;

				for (let i = 0; i < anchors.length; i++) {
					const anchorID = `#${anchors[i]}`;
					const element = document.querySelector(anchorID);
					if (element && scrollPosition >= element.offsetTop) {
						this.tabSelectIndex = i;
					}
				}

				if (scrollPosition < 200) {
					this.tabSelectIndex = -1;
				}
			},
			clickTabIndex(index, selector) {
				if (this.tabSelectIndex == index) {
					return
				}
				this.tabSelectIndex = index;
				const element = document.getElementById(selector);
				if (element) {
					element.scrollIntoView({
						behavior: 'smooth'
					});
				}
			},
			clickQu(index) {
				this.selectQu = index;
			},
			clickSend() {
				if (this.removeSpaces(this.userName).length == 0) {
					alert('お名前を入力してください。');
					return;
				}

				if (this.removeSpaces(this.userContent).length == 0) {
					alert('お問い合わせ内容を入力してください。');
					return;
				}

				if (this.removeSpaces(this.userEmail).length == 0) {
					alert('メールをお願いします。');
					return;
				}

				// 使用正则表达式验证邮箱格式
				const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
				if (!emailPattern.test(this.userEmail)) {
					alert('正しいメールアドレスを入力してください');
					return;
				}

				if (this.isSend) {
					return
				}
				this.isSend = true;

				axios.post('https://api-dev.treasureshub.jp/app/suggestion/send', {
					"name": this.userName, // 姓名
					"type": this.contents[this.selectQu], // 类型
					"context": this.userContent, // 内容
					"email": this.userEmail // 邮箱
				}).then(res => {
					alert('送信完了');
					console.log(res);
				}).catch(error => {
					console.error('请求用户数据出错:', error);
				});
			},
			removeSpaces(str) {
				return str.replace(/\s+/g, '');
			}
		}
	};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped lang="css" src="../assets/common.css" />